import { useCallback } from "react";
import { useAuthQuery } from "./useAuthQuery";

export const useGetFuelRequestsHistory = (queryBody) => {
  const select = useCallback((response) => {
    return response?.data?.data?.fuelRequests;
  }, []);

  const response = useAuthQuery(
    {
      method: "POST",
      url: "/fuelrequest/list",
      data: queryBody,
    },
    { queryKey: ["fuel-requests-history", queryBody], select }
  );

  return response;
};
